{
  "title": {
    "create": "Schedule a text message for {{title}}",
    "edit": "Scheduled text message for {{title}}"
  },
  "applies_to_instance": {
    "recurring": "Message applies to the {{date}} instance of this series",
    "all_day": "For the item starting on {{date}}"
  },
  "when": {
    "label": "When should the message go out?",
    "minutes_before": "Minutes before",
    "minutes_after": "Minutes after",
    "hours_before": "Hours before",
    "hours_after": "Hours after",
    "day_of": "Day of",
    "day_before": "Day before",
    "day_after": "Day after"
  },
  "who": {
    "label": "Who should receive the message?"
  },
  "what": {
    "label": "What should the message say?",
    "ai_title": "Write with AI",
    "ai_disabled_tooltip": "Add a title to your item to write a message with AI",
    "ai_error_toast": "Error suggesting a text message"
  },
  "errors": {
    "min_minutes_value": "Minimum value is 15 minutes",
    "gt_zero": "Value must be greater than 0",
    "time_required": "Enter a time",
    "message_required": "Message is required"
  },
  "actions": {
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "delete_confirm": "Confirm"
  },
  "add_recipient": "Add a recipient",
  "add_recipient_tooltip": "Add a recipient to save this message"
}
